/**
 * Floating Select Component
 *
 * Similar to the floating input component but for select elements. It is used in the 
 * Host app to select a team to give bonus points. The component has props for 
 * placeholder, value, name, disabled, and options. It also has state for focus and 
 * filled. The component renders a select element with options and updates its state 
 * based on user interaction.
 */

import React from 'react'

class FloatingSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      focus: false,
      filled: false,
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onFocus = this.onFocus.bind(this)
  }

  componentDidMount() {
    if (this.props.value && this.props.value.toString().length) {
      this.setState({ filled: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value) {
      if (this.props.value && this.props.value.toString().length) {
        this.setState({ filled: true })
      }
    }
  }

  onChange(event) {
    event.preventDefault()
    this.props.onChange(event)
    this.setState({ filled: event.target.value.toString().length != 0 })
  }

  onFocus(event) {
    this.setState({ focus: true })
  }

  onBlur(event) {
    this.setState({ focus: false })
  }

  render() {
    const { placeholder, value, name, disabled, options } = this.props
    const focus_class = this.state.focus ? `is-focused` : ``
    const filled_class = this.state.filled ? `is-filled` : ``
    return (
      <div className={`form-group mt-3 ${focus_class} ${filled_class}`}>
        <label className="label-floating" htmlFor={name}>
          {placeholder}
        </label>
        <select
          className={`form-control`}
          name={name}
          value={value}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          disabled={disabled}>
          {options.length &&
            options.map(option => (
              <option key={`option-${option.value}`} value={option.value}>
                {option.name}
              </option>
            ))}
        </select>
      </div>
    )
  }
}

FloatingSelect.defaultProps = {
  disabled: false,
  placeholder: `Enter Value`,
  value: ``,
  name: `floating`,
  options: [
    {
      name: `None`,
      value: ``,
    },
  ],
}

export default FloatingSelect
